"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _immutable = require("immutable");
var _api = require("../../helpers/api.js");
var _createAction = require("../../helpers/createAction.js");
var _constants = require("../../constants");
var Organizations = /*#__PURE__*/_createClass(function Organizations(api) {
  var _this = this;
  _classCallCheck(this, Organizations);
  this.organizationSelect = function (organizationId, user) {
    return function (dispatch, getState) {
      var _getState = getState(),
        organizationalMemberships = _getState.organizationalMemberships,
        session = _getState.session,
        assignments = _getState.assignments;
      var currentUserId = user.get('id');
      var isAdminUser = ['admin', 'distributor'].includes(user.get('internal_role'));

      // Skip no-op action if this organization is already selected
      if (organizationId === session.get('selected_organization_id')) return;
      var staffMemberships = organizationalMemberships.filter(function (membership) {
        return membership.get('user_id') === currentUserId && !membership.get('deactivated') && membership.get('verified') && ['admin', 'instructor', 'super admin'].includes(membership.get('role'));
      });

      // Skip action unless the current user has an active & verified staff membership for the organization
      if (!staffMemberships.find(function (membership) {
        return membership.get('organization_id') === organizationId;
      }) && !isAdminUser) return;
      var whitelistedUserIds = new _immutable.Set(assignments.filter(function (assignment) {
        return assignment.get('assigned_to_current_user');
      }).toList().map(function (assignment) {
        return assignment.get('creator_id');
      })).toArray();
      whitelistedUserIds.push(currentUserId);
      _this.api.put("".concat((0, _api.currentUserUrl)(getState()), "/organizations/").concat(organizationId, "/select"));
      dispatch({
        type: _constants.ORGANIZATION_SELECTED,
        payload: {
          organizationId: organizationId,
          whitelistedUserIds: whitelistedUserIds,
          currentUserId: currentUserId
        }
      });

      // Start other async things if needed
    };
  };

  this.organizationFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(organizationId) {
      return "organizations/".concat(organizationId);
    },
    request: function request(getState, organizationId) {
      return _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/organizations/").concat(organizationId));
    },
    loadingConstant: _constants.ORGANIZATION_FETCHING,
    loadedConstant: _constants.ORGANIZATION_FETCHED,
    errorConstant: _constants.ORGANIZATIONS_FETCH_ERROR
  });
  this.organizationMembersFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        organizationId = _ref.organizationId,
        query = _ref.query,
        pageNumber = _ref.pageNumber;
      return "organizations/".concat(organizationId, "/members?query=").concat(query, "&page=").concat(pageNumber);
    },
    request: function request(getState) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        organizationId = _ref2.organizationId,
        loadSubscriptions = _ref2.loadSubscriptions,
        query = _ref2.query,
        pageNumber = _ref2.pageNumber,
        sortKey = _ref2.sortKey,
        ati = _ref2.ati,
        onlyStudents = _ref2.onlyStudents,
        fullAssociations = _ref2.fullAssociations;
      var options = {
        params: {
          load_subscriptions: loadSubscriptions,
          only_students: onlyStudents,
          full_associations: fullAssociations,
          query: query,
          page: pageNumber,
          sort_key: sortKey,
          ati: ati
        }
      };
      return _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/organizations/").concat(organizationId, "/members"), options);
    },
    loadingConstant: _constants.ORGANIZATION_MEMBERS_FETCHING,
    loadedConstant: _constants.ORGANIZATION_MEMBERS_FETCHED,
    errorConstant: _constants.ORGANIZATION_MEMBERS_FETCH_ERROR,
    paginationEndConstant: _constants.ORGANIZATION_MEMBERS_PAGINATED
  });
  this.organizationUnloadMembers = function () {
    return function (dispatch, getState) {
      var _getState2 = getState(),
        loadedAt = _getState2.loadedAt,
        users = _getState2.users,
        session = _getState2.session,
        organizationalMemberships = _getState2.organizationalMemberships;
      var userId = session.get('current_user_id');
      var currentUser = users.get(userId);
      if (!currentUser) return;
      var isAdminUser = ['admin', 'distributor'].includes(currentUser.get('internal_role'));
      var organizationId = session.get('selected_organization_id');
      var allMemberships = organizationalMemberships.filter(function (om) {
        return om.get('user_id') === userId;
      });
      var currentUserMemberships = allMemberships.filter(function (om) {
        return om.get('user_id') === userId || isAdminUser;
      });
      var key = _this.organizationMembersFetch.getKey({
        organizationId: organizationId,
        query: '',
        pageNumber: 1
      });
      var orgMembersLoaded = loadedAt.get(key);
      if (orgMembersLoaded) {
        dispatch({
          type: _constants.ORGANIZATION_UNLOAD_MEMBERS
        });
        dispatch({
          type: _constants.RELOAD_CURRENT_USER,
          payload: currentUser
        });
        dispatch({
          type: _constants.RELOAD_CURRENT_USER_MEMBERSHIPS,
          payload: currentUserMemberships
        });
      }
    };
  };
  this.organizationsFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey() {
      return 'organizations/';
    },
    request: function request(getState) {
      return _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/organizations"));
    },
    loadingConstant: _constants.ORGANIZATIONS_FETCHING,
    loadedConstant: _constants.ORGANIZATIONS_FETCHED,
    errorConstant: _constants.ORGANIZATIONS_FETCH_ERROR
  });
  this.api = api;
});
var _default = exports.default = Organizations;